import {ErrorHandler, Injectable, NgZone} from '@angular/core';
import {NotificationService} from "../service/notification.service";
import {HttpErrorResponse} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {LoggerService} from '../service/logger.service';

/*
  Centralized Error handling
  It is possible for us to throw the error back so that the service/component can handle
  https://medium.com/@amcdnl/global-error-handling-with-angular2-6b992bdfb59c
  handleError(error) {
    throw error;
  }
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler
{
  private regexList: RegExp[] = [
                                  /^https?:\/\/[^\/]+\/api\/v1\/tenants\/[a-f\d-]+\/appointments$/,
                                  /\/api\/v1\/users\/\d+\/messages/g
                                ];

  constructor( private logger: LoggerService,
    private notificationService: NotificationService,
    private zone: NgZone) {}

  private shouldSkipHandlingUrl(url: string): boolean {
    for (const regex of this.regexList) {
      if (regex.test(url)) {
        return true;
      }
    }
    return false;
  }

  // WE might want to let the component handle some errors.One way is to maintain an array of those URLS that are
  // marked as handled: https://chat.openai.com/c/d193015a-a67b-4698-917f-96378855dcfe
  async handleError(error: any)
  {
    // Log the error to console
    console.log(`Error Details`, error);
    // Show the dialog. We need to show the dialog inside the run so that snackbar works properly
    let message = 'There was an error. Please try again later.';
    let handled = false;
    // Check if the error is a HTTP Error
    if (error instanceof HttpErrorResponse) {
      if (error.status === 400)
      {
        if (error.url && this.shouldSkipHandlingUrl(error.url)) {
          // re-throw the error to let the component handle it
          throw error;
        }
        else {
          // Show the dialog
          await this.zone.run(() => this.notificationService.validationError(error.error));
          handled = true;
        }
      } else if (error.status === 401) {
        message = 'You are not authorized to access this page. Please make sure that you have logged in.';
        // Send the user to the login page
        this.zone.run(() => window.location.href = environment.loginUrl);
      }
      else {
        if (error.error?.detail) {
          message = error.error?.detail;
        }
      }
    }

    // Show the error message if not handled
    if (!handled) {
      await this.zone.run(() => this.notificationService.error(message));
    }
  }
}
